import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PreguntasList.module.css';

const API_URL =
  process.env.NODE_ENV === 'development'
    ? ''
    : (process.env.REACT_APP_API_URL || '');

function formatFecha(fechaStr) {
  if (!fechaStr) return '';
  const d = new Date(fechaStr);
  return d.toLocaleString('es-CO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export default function PreguntasList() {
  const [preguntas, setPreguntas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    let usuario;
    try {
      const stored = localStorage.getItem('usuario');
      usuario = stored ? JSON.parse(stored) : null;
    } catch {
      usuario = null;
    }

    if (!usuario) {
      navigate('/login');
      return;
    }
    if (!usuario.es_staff) {
      navigate('/');
      return;
    }

    const fetchPreguntas = async (showLoading = true) => {
      if (showLoading) {
        setLoading(true);
        setError('');
      }
      try {
        const res = await fetch(`${API_URL}/api/admin/preguntas`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cedula: usuario.cedula }),
        });
        const data = await res.json();
        if (res.ok) {
          setPreguntas(data.preguntas || []);
        } else if (showLoading) {
          setError(data.error || 'Error al cargar las preguntas.');
        }
      } catch (err) {
        console.error('[PreguntasList] Error:', err);
        if (showLoading) {
          setError('No se pudo conectar con el servidor.');
        }
      } finally {
        if (showLoading) {
          setLoading(false);
        }
      }
    };

    fetchPreguntas(true);

    const handleNuevaPregunta = () => fetchPreguntas(false);
    window.addEventListener('pregunta-nueva', handleNuevaPregunta);

    const interval = setInterval(() => fetchPreguntas(false), 5000);
    return () => {
      window.removeEventListener('pregunta-nueva', handleNuevaPregunta);
      clearInterval(interval);
    };
  }, [navigate]);

  return (
    <div className={styles.preguntasList}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.logoWrapper}>
            <div className={styles.logoCircle}>
              <img
                src={`${process.env.PUBLIC_URL}/logo.gif`}
                alt="4to MasterClass EPI"
                className={styles.logoImg}
              />
            </div>
          </div>
          <h1 className={styles.titulo}>Preguntas de los participantes</h1>
        </div>
      </section>

      <section className={styles.content}>
        <div className={styles.card}>
          {loading ? (
            <p className={styles.loading}>Cargando preguntas...</p>
          ) : error ? (
            <p className={styles.error}>{error}</p>
          ) : preguntas.length === 0 ? (
            <p className={styles.empty}>No hay preguntas registradas.</p>
          ) : (
            <ol className={styles.lista}>
              {preguntas.map((p) => (
                <li key={p.id} className={styles.item}>
                  <div className={styles.itemHeader}>
                    <span className={styles.autor}>{p.nombre_completo}</span>
                    <span className={styles.fecha}>{formatFecha(p.fecha_creacion)}</span>
                  </div>
                  <p className={styles.pregunta}>{p.pregunta}</p>
                </li>
              ))}
            </ol>
          )}
        </div>
      </section>
    </div>
  );
}
